import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import { awsConfig } from "./aws-config";
import "./index.css";
import "./styles/design-system.css";
import { ThemeProvider } from "./ThemeContext";
import { BackgroundProvider } from "./BackgroundContext";
import App from "./App";

// Connect frontend to AWS Cognito
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.userPoolId,
      userPoolClientId: awsConfig.userPoolClientId,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <ThemeProvider>
    <BackgroundProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </BackgroundProvider>
  </ThemeProvider>
);
